<template>
  <div
    class="tableModule"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(6, 16, 37, .8)"
    element-loading-customClass="tableLoading"
    ref="tableaa"
  >
    <div class="tableMine" ref="tableMine">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :height="tableHeight"
        ref="ammentTable"
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="setDisabled"
          :align="'center'"
          v-if="isSelectable"
        >
        </el-table-column>
        <template v-for="item in columns">
          <el-table-column
            v-if="item.scopedSlots"
            :label="item.title"
            :key="item.title"
            :align="item.align || 'center'"
            :header-align="item.headerAlign || 'center'"
            :width="item.width"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :sort-method="
              (before, after) => tableSort(before, after, item.dataIndex)
            "
            :prop="item.dataIndex"
          >
            <template slot-scope="scope">
              <slot :name="item.scopedSlots.customRender" :data="scope"></slot>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="item.dataIndex"
            :prop="item.dataIndex"
            :label="item.title"
            :align="item.align || 'center'"
            :header-align="item.headerAlign || 'center'"
            :width="item.width"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :sort-method="
              (before, after) => tableSort(before, after, item.dataIndex)
            "
          ></el-table-column>
        </template>
        <!-- 无数据 -->
        <template slot="empty">
          <div class="noData">
            <img src="./../../../assets/image/noData.png" alt="" />
            <p>暂无数据</p>
          </div>
        </template>
      </el-table>
    </div>
    <div class="pagination" v-if="isPagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "wtable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    pageSizes: {
      type: Array,
      default: () => [10, 100, 200, 500],
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    isSetChecked: {
      type: Boolean,
      default: false,
    },
    isSetDisabled: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    pageNo: {
      type: Number,
      default: 1,
    },
    isPagination: {
      type: Boolean,
      default: true,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      tableHeight: 0,
    };
  },
  mounted() {
    this.tableInit();
  },
  methods: {
    // table 初始化
    tableInit() {
      // max高度设置
      this.$nextTick(() => {
        if (this.height != 0) {
          this.tableHeight = this.height;
        } else {
          if (this.$refs.tableMine) {
            let height = this.$refs.tableMine.offsetHeight;
            this.tableHeight = height;
          }
        }
      });
      if (this.isSetChecked) {
        this.setChecked();
      }
    },
    // 设置禁选项
    setDisabled(row, index) {
      if (this.isSetDisabled && row.date == "2016-05-04") {
        return false;
      } else {
        return true;
      }
    },
    // 设置为选择状态
    setChecked() {
      // console.log(this.tableData);
      // //   原灯设置为选择状态
      // this.$refs.ammentTable.toggleRowSelection(this.tableData[1], true);
    },
    // 选择框改变
    selectionChange(e) {
      this.$emit("selectionChange", e);
    },
    // 分页每页数量改变
    handleSizeChange(val) {
      this.$emit("sizeChange", val);
    },
    // 分页页码改变
    handleCurrentChange(val) {
      this.$emit("currentChange", val);
    },
    tableSort(before, after, key) {
      if (this.isHexadecimal(before[key])) {
        return (
          parseInt(before[key].replace(/\s+/g, ""), 16) -
          parseInt(after[key].replace(/\s+/g, ""), 16)
        );
      } else {
        if (parseInt(before[key]) || before[key] === null) {
          return Number(before[key]) - Number(after[key]);
        } else {
          return before[key].localeCompare(after[key]);
        }
      }
    },
    isHexadecimal(num) {
      let hexvalue = null;
      if (num) {
        hexvalue = num.replace(/\s+/g, "");
      }
      var reghex = /^[A-Fa-f0-9]{1,4}$/;
      if (reghex.test(hexvalue)) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tableModule {
  flex: 1;
  display: flex;
  flex-direction: column;
  .tableMine {
    flex: 1;
    min-width: 0;
    min-height: 0;
    .noData {
      padding-top: 12px;
      img {
        width: 120px;
      }
      p {
        line-height: 30px;
      }
    }
  }
  .pagination {
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 12px;
  }
  /deep/ .el-icon-loading {
    font-size: 48px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/publicPage/table.vue